/**
 * NotificationSignupBlock — Renderer for NOTIFICATION_SIGNUP content blocks.
 *
 * Displays a notification signup teaser with channel badges. The form is
 * intentionally non-interactive until the backend subscription endpoint is
 * wired — rendering a "coming soon" state prevents collecting user data
 * that would be silently discarded.
 */

import "./NotificationSignupBlock.scss";

const VALID_CHANNELS = new Set(["email", "push"]);

interface NotificationSignupConfig {
    heading?: string;
    description?: string;
    buttonText?: string;
    channels?: string[];
    successMessage?: string;
}

interface NotificationSignupBlockProps {
    config?: NotificationSignupConfig;
    sectionTitle?: string;
}

export const NotificationSignupBlock = ({ config, sectionTitle }: NotificationSignupBlockProps) => {
    const heading = config?.heading || "Stay Updated";
    const channels = (config?.channels || ["email"]).filter(ch => VALID_CHANNELS.has(ch));

    return (
        <div className="notification-signup">
            {sectionTitle && <h2 className="section-title">{sectionTitle}</h2>}
            <h3 className="notification-signup__heading">{heading}</h3>
            {config?.description &&
                <p className="notification-signup__description">{config.description}</p>
            }
            <div className="notification-signup__channels">
                {channels.map(ch =>
                    <span key={ch} className={`notification-signup__channel notification-signup__channel--${ch}`}>
                        {ch === "email" ? "Email" : "Push"}
                    </span>)}
            </div>
            <p className="notification-signup__coming-soon">
                Notifications coming soon
            </p>
        </div>
    );
};
